module.exports = __webpack_public_path__ + "img/jm.3277ad43.svg";